<template>
    <BCard class="mb-4 border-info shadow-sm">
        <template #header>
            <h5 class="mb-0 text-info font-weight-bold text-left">4. Pricing Summary</h5>
        </template>
        
        <div class="p-2">
            <BRow>
                <!-- Left: Remarks -->
                <BCol md="7" class="text-left">
                    <BFormGroup label="Remarks (Optional)" class="mb-3">
                        <BFormTextarea
                            v-model="form.remarks"
                            placeholder="Enter remarks here..."
                            rows="6"
                        />
                    </BFormGroup>
                </BCol>

                <!-- Right: Pricing Table -->
                <BCol md="5">
                    <div class="card bg-light border-0 p-4 shadow-none">
                        <h6 class="font-weight-bold mb-4 border-bottom pb-2 text-left">Total Price</h6>
                        <BTableSimple small borderless class="mb-0">
                            <BTbody>
                                <BTr>
                                    <BTd class="text-left text-muted">Total Salary (Program)</BTd>
                                    <BTd class="text-end font-weight-bold">{{ formatCurrency(totalSalary) }}</BTd>
                                </BTr>
                                <BTr>
                                    <BTd class="text-left text-muted">Total Parking Fee</BTd>
                                    <BTd class="text-end font-weight-bold">{{ formatCurrency(totalParking) }}</BTd>
                                </BTr>
                                <BTr>
                                    <BTd class="text-left text-muted">Total Entrance Fee</BTd>
                                    <BTd class="text-end font-weight-bold">{{ formatCurrency(totalEntrance) }}</BTd>
                                </BTr>
                                <BTr>
                                    <BTd class="text-left text-muted">Total Hotel Fee</BTd>
                                    <BTd class="text-end font-weight-bold">{{ formatCurrency(totalHotel) }}</BTd>
                                </BTr>
                                <BTr>
                                    <BTd class="text-left text-muted">Total Other Fee</BTd>
                                    <BTd class="text-end font-weight-bold">{{ formatCurrency(totalOthers) }}</BTd>
                                </BTr>
                                <BTr class="border-top h5">
                                    <BTd class="text-left pt-3 font-weight-bold text-primary">Grand Total</BTd>
                                    <BTd class="text-end pt-3 text-primary font-weight-bold">{{ formatCurrency(grandTotal) }}</BTd>
                                </BTr>
                            </BTbody>
                        </BTableSimple>
                    </div>
                </BCol>
            </BRow>
        </div>
    </BCard>
</template>

<script setup>
import { inject, computed, watch } from "vue";
import { BTableSimple, BTbody, BTr, BTd, BCard, BFormGroup, BRow, BCol, BFormTextarea } from "bootstrap-vue-next";

const form = inject('form');

const totalSalary = computed(() => {
    return (form.programs || []).reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
});

const totalEntrance = computed(() => {
    return (form.entrance_fees || []).reduce((sum, item) => sum + (parseFloat(item.subtotal) || 0), 0);
});

const totalParking = computed(() => {
    return (form.parking_fees || []).reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
});

const totalOthers = computed(() => {
    return (form.other_fees || []).reduce((sum, item) => sum + (parseFloat(item.subtotal) || 0), 0);
});

const totalHotel = computed(() => {
    return (form.hotel_fees || []).reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
});

const grandTotal = computed(() => {
    return totalSalary.value + totalEntrance.value + totalParking.value + totalOthers.value + totalHotel.value;
});

// Update main form grand_total whenever it changes
watch(grandTotal, (val) => {
    form.grand_total = val;
});

const formatCurrency = (val) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val);
};
</script>
